import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

import { FIREBASE_REGION } from "./context";

import {
  CallableFunctionId,
  HTTPFunctionResponse,
  FunctionResponse,
  FetchLogsFunctionOptions,
  FetchLogsFunctionResponse,
  FetchUserTemplatesFunctionResponse,
} from "@msend/types";

export const getFunction = <T = never, R = FunctionResponse>(
  name: CallableFunctionId
) => {
  return httpsCallable(getFunctions(getApp(), FIREBASE_REGION), name) as (
    data?: T
  ) => Promise<HTTPFunctionResponse<R>>;
};

export const getFetchUserTemplates = () =>
  getFunction<{}, FetchUserTemplatesFunctionResponse>("emailTemplates-fetch");

/**
 * Get the cloud function to sync email templates.
 */
export const getSyncTemplates = () => getFunction("sendgrid-getTemplates");

/**
 * Get the cloud function to send an email.
 */
export const getSendEmail = () =>
  getFunction<{ emailId: string; idempotencyKey: string }>("emails-send");

/**
 * Get the cloud function to fetch logs.
 */
export const getFetchLogs = () =>
  getFunction<FetchLogsFunctionOptions, FetchLogsFunctionResponse>("logs-fetch");
